export const syncChannel = new MessageChannel();
